<div class="m-3">
  <label class="rounded p-1 w-full border border-gray-400">
    <input class="hidden" (change)="onFileChange($event)" type="file" />
    Upload Excel File
  </label>
  <div *ngIf="document$$ | async as doc" class="mt-4">
    <button mat-stroked-button color="primary" (click)="upload()">Upload {{ doc.name }}</button>
  </div>
  <div *ngIf="responses$$ | async as responses">
    <div *ngIf="responses.length > 0" class="grid grid-cols-3 gap-x-1 bg-gray-500 m-1">
      <div class="p-1 h-full flex flex-col gap-y-1">
        <div class="flex flex-row">
          <div class="font-semibold text-lg">Loads with Errors</div>
          <lohi-number-badge [count]="(errorResponses$ | async).length" [showIfZero]="true"></lohi-number-badge>
        </div>
        <div
          *ngFor="let response of errorResponses$ | async; trackBy: errorResponses$ | trackByKey2: 'orderId'"
          class="flex flex-col p-2 bg-white"
        >
          <div class="text-lg w-full flex items-center">
            <div class="mr-2">{{ response.orderId }}</div>
            <div>❌</div>
          </div>
          <div>
            <div *ngIf="isString(response.error) as errStr">
              {{ errStr }}
            </div>
            <div *ngIf="isDriverNotFoundErr(response.error) as driverNotFoundError">
              <div>{{ driverNotFoundError.errorString }}</div>
              <div>Using trailer {{ driverNotFoundError.trailerName }}</div>
              <div mat-flat-button color="primary" (click)="promptAddDriver(driverNotFoundError.driverName)">
                <pre>{{ driverNotFoundError.driverName }}</pre>
              </div>
              <button
                mat-flat-button
                color="primary"
                *ngIf="!nameAdded(driverNotFoundError.driverName); else nameAlreadyAdded"
                (click)="promptAddDriver(driverNotFoundError.driverName)"
              >
                Add User ID
              </button>
              <ng-template #nameAlreadyAdded>
                User ID Added - matched to {{ userMappingsCreated[driverNotFoundError.driverName]?.driverName }} ({{
                  userMappingsCreated[driverNotFoundError.driverName]?.phoneNumber
                }})</ng-template
              >
              <div *ngIf="driverNotFoundError.possibleDrivers?.length">
                <div class="text-red-500 text-xl">
                  Below are drivers we found with the same trailer number. Sometimes these are checked out by other
                  drivers and admins so please check the name and DO NOT JUST ASSUME. This could even be the wrong
                  company!!!!!
                </div>
                <div
                  *ngFor="
                    let pd of driverNotFoundError.possibleDrivers;
                    trackBy: driverNotFoundError.possibleDrivers | trackByKey2: 'userId'
                  "
                  class="my-2 border-b border-gray-500"
                >
                  <div class="flex">
                    <div class="flex-1 font-bold">Company:</div>
                    <div class="flex-1">{{ pd.companyName }}</div>
                  </div>
                  <div class="flex">
                    <div class="flex-1 font-bold">Name:</div>
                    <div class="flex-1">{{ pd.name }}</div>
                  </div>
                  <div class="flex">
                    <div class="flex-1 font-bold">Phone:</div>
                    <div class="flex-1">{{ pd.phone }}</div>
                  </div>
                  <div class="flex">
                    <div class="flex-1 font-bold">Trailer Checked Out At:</div>
                    <div class="flex-1">{{ pd.trailerCheckoutAt | standardDate }}</div>
                  </div>
                  <div class="flex">
                    <div class="flex-1 font-bold">User ID:</div>
                    <div class="flex-1">{{ pd.userId }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isNoCompanyAtAcceptError(response.error) as noCompanyError">
              The driver {{ noCompanyError.driverName }} ({{ noCompanyError.driverId }}) was not onboarded before this
              load was completed. You will need a dev's help to change their onboarding date. Note for devs, the
              created_at date in the user_company table needs to be before this load accept time.
            </div>
          </div>
        </div>
      </div>
      <div class="p-1 h-full flex flex-col gap-y-1">
        <div class="flex flex-row">
          <div class="font-semibold text-lg">Loads Uploaded</div>
          <lohi-number-badge
            [count]="(uploadedResponses$ | async).length"
            [showIfZero]="true"
            bgClass="bg-green-500"
          ></lohi-number-badge>
        </div>
        <div
          *ngFor="let response of uploadedResponses$ | async; trackBy: uploadedResponses$ | trackByKey2: 'orderId'"
          class="flex flex-col p-2 bg-white"
        >
          <div class="text-lg w-full flex items-center">
            <div class="mr-2">{{ response.orderId }}</div>
            <div>✅</div>
          </div>
        </div>
      </div>
      <div class="p-1 h-full flex flex-col gap-y-1">
        <div class="flex flex-row">
          <div class="font-semibold text-lg">Loads Already Uploaded</div>
          <lohi-number-badge
            [count]="(alreadyUploadedResponses$ | async).length"
            [showIfZero]="true"
            bgClass="bg-green-400"
          ></lohi-number-badge>
        </div>
        <div
          *ngFor="
            let response of alreadyUploadedResponses$ | async;
            trackBy: alreadyUploadedResponses$ | trackByKey2: 'orderId'
          "
          class="flex flex-col p-2 bg-white"
        >
          <div class="text-lg w-full flex items-center">
            <div class="mr-2">{{ response.orderId }}</div>
            <div>✅</div>
          </div>
          <div>This load was already uploaded, nothing has changed</div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addDriverMatchingModal>
  <div mat-dialog-title>
    Add Driver Matching for
    <pre>{{ driverNameForMatching }}</pre>
  </div>
  <mat-form-field class="w-full">
    <mat-label>Driver ID</mat-label>
    <input matInput [formControl]="driverIdForMatchingControl" />
  </mat-form-field>
  <div mat-dialog-actions class="mt-1 flex justify-between">
    <button mat-button matDialogClose>Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!driverIdForMatchingValid" (click)="addDriver()">
      Add Driver Matching
    </button>
  </div>
</ng-template>
